import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`widget`, [
  `radius`,
  `padding-vertical`,
  `padding-horizontal`,
  `gap`,
  `background`,
  `border-color`,
  `shadow`,
]);
